import { convertStageFromServer } from "../../utils/stage";
import { convertTaskFromServer } from "../../utils/task";
import { SET_USER_PAGE_TASK_DATA, SET_USER_PAGE_TASK_LOADING, UPDATE_USER_PAGE_TASK_DATA, UPDATE_USER_PAGE_TASK_DONE, UPDATE_USER_PAGE_TASK_STAGE, } from "../constants";
const reducer = (state, action) => {
    switch (action.type) {
        case SET_USER_PAGE_TASK_DATA: {
            const data = action.payload;
            return Object.assign(Object.assign({}, state), { task: convertTaskFromServer(data.task), taskStages: data.stages.map(convertStageFromServer), customFields: data.customFields });
        }
        case UPDATE_USER_PAGE_TASK_DATA: {
            const data = action.payload;
            return Object.assign(Object.assign({}, state), { task: convertTaskFromServer(data) });
        }
        case SET_USER_PAGE_TASK_LOADING: {
            return Object.assign(Object.assign({}, state), { loading: action.payload });
        }
        case UPDATE_USER_PAGE_TASK_STAGE: {
            const stageId = action.payload;
            return Object.assign(Object.assign({}, state), { task: state.task
                    ? Object.assign(Object.assign({}, state.task), { stage_id: stageId }) : null });
        }
        case UPDATE_USER_PAGE_TASK_DONE: {
            const { done } = action.payload;
            return Object.assign(Object.assign({}, state), { task: state.task
                    ? Object.assign(Object.assign({}, state.task), { is_done: done }) : null });
        }
        default:
            return state;
    }
};
export { reducer };
